import type { ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const isRenderFunction = <T extends Function>(argument: ReactNode | T): argument is T => typeof argument === 'function';
